import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Image, Tag} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";

export default class SkillList extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getPersonageCapList,
        otherParam: null,
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: '请输入技能名称或描述搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.keyWord = value.keyword
            }
            delete value.keyword

            return true;
          },
        }
      }
    }
  }


  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          field: "tags",
          name: "商品状态",
          type: 'selectAll',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            mode: 'multiple',
            allowClear: true,
          },
          data: [
            {
              title: '热门',
              value: 'hot',
            },
            {
              title: '已推荐',
              value: 'recommend',
            },
            {
              title: '未推荐',
              value: 'off',
            },
          ]
        },
        {
          field: "createName",
          name: "创建人",
          type: 'Input',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
        },
        {
          field: "sortType",
          name: "排序方式",
          type: 'radio',
          reg: (v) => {
            return true;
          },
          option: {
            defaultValue: 'updateTime'
          },
          data: [
            {
              title: '按更新时间',
              value: 'updateTime',
            },
            {
              title: '按热度',
              value: 'heat',
            },
          ]
        },
      ],
    }
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        render: (text, record, index) => {
          return <div>{index + 1}</div>
        }
      },
      {
        title: '图标',
        dataIndex: 'logoUrl',
        key: 'logoUrl',
        render: (text, record, index) => {
          return <Image
            width={50}
            src={text}
          />
        }
      },
      {
        title: '技能名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '技能类型',
        dataIndex: 'capType',
        key: 'capType',
        render: (text, record)=>{
          return record.capType === 1?<Tag color="#ff834f">主动</Tag>:<Tag color="#1ca6ec">被动</Tag>
        }
      },
      {
        title: '技能描述',
        dataIndex: 'remark',
        key: 'remark',
        width: 250,
        render: (text, record, index) => {
          return <Popover
            title={"描述详情"}
            content={
              <div
                style={{maxWidth: '50vw'}}
              >
                {text}
              </div>
            }
          >
            <div
              style={{width: '250px'}}
              className={styles.oneLineText}
            >
              {text}
            </div>
          </Popover>
        }
      },
      {
        title: '推荐状态',
        dataIndex: 'systemTag',
        key: 'systemTag',
        render: (text) => {
          return text === 'recommend' ? <span style={{color: 'dodgerblue'}}>已推荐</span> :
            <span style={{color: 'darkorange'}}>未推荐</span>
        }
      },
      {
        title: '热度(浏览量)',
        dataIndex: 'heat',
        key: 'heat',
        render: (text) => {
          return <div>{window.formatBigNumW(text)}</div>
        }
      },
      {
        title: '创建人',
        dataIndex: 'createUserName',
        key: 'createUserName',
        render: (text, record) => {
          return <div>{record.developer?.createName || '-'}</div>
        }
      },
      {
        title: '更新时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        render: (text) => {
          let time = text?TimeHelp.getYMDHM(text):'-';
          return <div>{time}</div>
        }
      },
      {
        title: '更新人',
        dataIndex: 'updaterName',
        key: 'updaterName',
        render: (text, record) => {
          return <div>{record.developer?.updateName || '-'}</div>
        }
      },
      {
        title: '操作',
        width: 200,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.systemTag === 'recommend' ? <span onClick={() => {
                      this.changeState(record._id, 'off')
                    }} style={{color: "darkorange"}} className={styles.btnCopy}>{"取消推荐"}</span> :
                    <span onClick={() => {
                      this.changeState(record._id, 'recommend')
                    }} style={{color: "dodgerblue"}} className={styles.btnEdit}>{"设置推荐"}</span>)
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(id, systemTag) {
    Modal.confirm({
      title: '提示',
      content: "确定" + (systemTag === 'recommend' ? "推荐" : "取消推荐") + "该技能吗？",
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _ids: [id],
          systemTag,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.setPersonageCapSystemTag, successCB, failureCB, param);
      }
    })
  }
}